export enum ShippingStorageTemp {
  FAHRENHEIT = 'F',
  CELSIUS = 'C'
}
